import { render, staticRenderFns } from "./TresTemplate.vue?vue&type=template&id=51251b30&"
import script from "./TresTemplate.vue?vue&type=script&lang=js&"
export * from "./TresTemplate.vue?vue&type=script&lang=js&"
import style0 from "./TresTemplate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports